import * as S from './LangSelfAssessment.styled';

import {
    ListTable,
    LTHeader,
    LTItem,
    LTRow,
    LTMobileItem,
    LTPlaceholder,
} from 'components/common/ListTable';

const IELTS_TABLE = [
    [
        9,
        'Expert user',
        'The test taker has fully operational command of the language. Their use of English is appropriate, accurate and fluent, and shows complete understanding.',
    ],
    [
        8,
        'Very good user',
        'The test taker has fully operational command of the language with only occasional unsystematic inaccuracies and inappropriate usage. They may misunderstand some things in unfamiliar situations. They handle complex and detailed argumentation well.',
    ],
    [
        7,
        'Good user',
        'The test taker has operational command of the language, though with occasional inaccuracies, inappropriate usage and misunderstandings in some situations. They generally handle complex language well and understand detailed reasoning.',
    ],
    [
        6,
        'Competent user',
        'The test taker has an effective command of the language despite some inaccuracies, inappropriate usage and misunderstandings. They can use and understand fairly complex language, particularly in familiar situations.',
    ],
    [
        5,
        'Modest user',
        'The test taker has a partial command of the language and copes with overall meaning in most situations, although they are likely to make many mistakes. They should be able to handle basic communication in their own field.',
    ],
    [
        4,
        'Limited user',
        "The test taker's basic competence is limited to familiar situations. They frequently show problems in understanding and expression. They are not able to use complex language.",
    ],
    [
        3,
        'Extremely limited user',
        'The test taker conveys and understands only general meaning in very familiar situations. There are frequent breakdowns in communication.',
    ],
    [
        2,
        'Intermittent user',
        'The test taker has great difficulty understanding spoken and written English.',
    ],
    [
        1,
        'Non-user',
        'The test taker has no ability to use the language except a few isolated words.',
    ],
    [0, 'Did not attempt the test', 'The test taker did not answer the questions.'],
];

export const LanguageSelfAssessment = () => {
    return (
        <>
            <S.SelfAssessmentSection>
                <S.Content>
                    <S.Main>
                        <S.InnerContent>
                            <S.Title>Language assessment scale</S.Title>

                            <S.DisplayContent>
                                <div>
                                    <ListTable>
                                        <LTHeader flexStart={true}>
                                            <LTItem minWidth="130px">Band score</LTItem>
                                            <LTItem minWidth="130px">Skill level</LTItem>
                                            <LTItem minWidth="130px">Description</LTItem>
                                        </LTHeader>
                                        {IELTS_TABLE.length === 0 && (
                                            <LTPlaceholder>the list is empty</LTPlaceholder>
                                        )}
                                        {IELTS_TABLE.map((value, i) => (
                                            <LTRow flexStart={true} key={i}>
                                                {/*FULL SCREEN VERSION*/}
                                                <LTItem
                                                    minWidth="130px"
                                                    style={{ paddingLeft: '2em' }}
                                                >
                                                    {value[0]}
                                                </LTItem>
                                                <LTItem
                                                    minWidth="130px"
                                                    maxWidth="130px"
                                                    style={{
                                                        whiteSpace: 'normal',
                                                        paddingRight: '1em',
                                                    }}
                                                >
                                                    {value[1]}
                                                </LTItem>
                                                <LTItem
                                                    minWidth="130px"
                                                    style={{ whiteSpace: 'normal' }}
                                                >
                                                    {value[2]}
                                                </LTItem>
                                                {/*SMALL SCREEN VERSION*/}
                                                <LTMobileItem name="Band score">
                                                    <span>{value[0]}</span>
                                                </LTMobileItem>
                                                <LTMobileItem name="Skill level">
                                                    <span>{value[1]}</span>
                                                </LTMobileItem>
                                                <LTMobileItem
                                                    name="Description"
                                                    style={{ alignItems: 'stretch' }}
                                                >
                                                    <span>{value[2]}</span>
                                                </LTMobileItem>
                                            </LTRow>
                                        ))}
                                    </ListTable>
                                </div>
                            </S.DisplayContent>
                        </S.InnerContent>
                    </S.Main>
                </S.Content>
            </S.SelfAssessmentSection>
        </>
    );
};
